import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    data: { title: 'Happyland Recarga Express' },
    redirectTo: '/portal',
    pathMatch: 'full',
  },
  {
    path: '',
    children: [
      {
        path: 'card-error',
        loadChildren: () => import('./pages/error-card-page/error-card-page.module').then((m) => m.ErrorCardPageModule),
      },
      {
        path: 'server-error',
        loadChildren: () => import('./pages/error-page/error-page.module').then((m) => m.ErrorPageModule),
      },
      {
        path: 'portal',
        loadChildren: () => import('./pages/promotion-portal/promotion-portal.module').then((m) => m.PromotionPortalModule),
      },
      {
        path: 'portal/:card',
        loadChildren: () => import('./pages/promotion-portal/promotion-portal.module').then((m) => m.PromotionPortalModule),
      },
      {
        path: 'payment-page',
        loadChildren: () => import('./pages/payment-portal/payment-portal.module').then((m) => m.PaymentPortalModule),
      },
      {
        path: 'payment-complete',
        loadChildren: () => import('./pages/payment-complete/payment-complete.module').then((m) => m.PaymentCompleteModule),
      },
      {
        path: 'refund',
        loadChildren: () => import('./pages/refund-page/refund-page-routing.module').then((m) => m.RefundPageRoutingModule),
      },
      {
        path: 'oneclick',
        loadChildren: () => import('./pages/oneclick-page/oneclick-page.module').then((m) => m.OneclickPageModule),
      },
      {
        path: 'oneclick/confirm',
        loadChildren: () => import('./pages/oneclick-confirm/oneclick-confirm.module').then((m) => m.OneclickConfirmModule),
      },
      {
        path: 'webpay',
        loadChildren: () => import('./pages/webpay-page/webpay-page.module').then((m) => m.WebpayPageModule),
      },
      {
        path: 'my-happy-plus',
        loadChildren: () => import('./pages/my-happy-profile/my-happy-profile.module').then((m) => m.MyHappyProfileModule),
      },
      // Historical portal has been migrated to bottom-sheet component
      // {
      //   path: 'historical',
      //   loadChildren: () => import('./pages/historical-portal/historical-portal.module').then((m) => m.HistoricalPortalModule),
      // },
      // {
      //   path: 'waiver',
      //   loadChildren: () => import('./pages/temporary-waiver/temporary-waiver.module').then((m) => m.TemporaryWaiverModule),
      // },
      {
        path: 'waiver',
        loadChildren: () => import('./pages/waiver-page/waiver-page.module').then((m) => m.WaiverPageModule),
      },
      {
        path: 'mercadopago',
        loadChildren: () => import('./pages/mercadopago-page/mercadopago-page.module').then((m) => m.MercadopagoPageModule),
      },
    ],
  },
];

@NgModule({
  imports: [CommonModule, RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
  declarations: [],
})
export class AppRoutingModule {}
